<template>
  <div v-if="express"
       class="page-express-detail"
  >
    <div class="page-express-detail-header">
      <div class="item-info">
        <span class="item-desc">物流公司</span>
        <span class="item-name">{{ express.company }}</span>
      </div>
      <div class="item-info">
        <span class="item-desc">运单号码</span>
        <clip-board :value="express.postId"
                    color='#666'
        />
      </div>
    </div>
    <div class="page-express-detail-address">
      <div class="address-icon">收</div>
      <div class="address-text">{{ express.address }}</div>
    </div>
    <div v-if="expressResult.length !== 0"
         class="page-express-detail-express-result"
    >
      <div class="page-express-detail-express-result-block"
           v-for="(block, index) in expressResult"
           :key="index"
      >
        <div v-if="block.status && block.status !== ''"
             class="page-express-detail-express-result-block-header"
             :class="{ 'high-light': index === 0 }"
        >
          <div class="icon-container">
            <ym-icon class="icon"
                     :name="addIcon(block.status)"
            />
          </div>
          <span>{{ block.status }}</span>
        </div>
        <div class="page-express-detail-express-result-block-list block-list">
          <div class="page-express-detail-express-result-block-list-item"
               v-for="(item, itemIndex) in block.list"
               :key="itemIndex"
          >
            <div class="page-express-detail-express-result-block-list-item-context"
                 v-html="item.context"
            ></div>
            <div class="page-express-detail-express-result-block-list-item-time">
              {{ item.time }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClipBoard from '@/components/ClipBoard';
  import { getExpressDetail } from '@/services/express';

  export default {
    name: 'ExpressDetail',
    metaInfo: {
      title: '物流详情',
    },
    components: {
      ClipBoard,
    },
    data() {
      return {
        express: null,
        expressResult: [],
      };
    },
    methods: {
      formatContext(context) {
        return context.replace(/[\d-]{3,}/g, phone => `<a href="tel:${phone}" class="primary-link">${phone}</a>`);
      },
      formatData(list) {
        const result = [];
        list.forEach((item) => {
          item.context = this.formatContext(item.context);
          if (result.length === 0) {
            result.push({
              status: item.status,
              list: [item],
            });
            return;
          }
          if (result[result.length - 1].status === item.status) {
            result[result.length - 1].list.push(item);
            return;
          }
          result.push({
            status: item.status,
            list: [item],
          });
        });
        return result;
      },
      async fetchData() {
        const data = await getExpressDetail(this.$route.params.sn);
        data.expressResult.push({
          status: '发货',
          context: '包裹正在等待揽收',
        });
        this.express = data.express;
        this.expressResult = this.formatData(data.expressResult);
      },
      // 添加图标变量
      addIcon(status) {
        switch (status) {
          case '发货': {
            return 'yifahuo';
          }
          case '揽收': {
            return 'yilanshou';
          }
          case '在途': {
            return 'logistics';
          }
          case '派件': {
            return 'deliver';
          }
          case '签收': {
            return 'select';
          }
          default: {
            return 'problem1';
          }
        }
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-express-detail {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: 100px;
    background: @color-white;
    &-header {
      padding: @size-base 0 @size-base @size-base;
      span {
        display: inline-block;
        width: 120px;
        margin-right: @size-small;
        color: @color-text-lighter;
        font-weight: @font-weight-primary;
        font-size: @font-size-base;
      }
      .item-info {
        display: flex;
        align-items: center;
        line-height: 1;
        .item-desc {
          margin-right: 18px;
        }
        .item-name {
          color: @color-text-light;
          font-weight: @font-weight-strong;
        }
        &:not(:last-child) {
          margin-bottom: 16px;
        }
      }
    }
    &-address {
      background: @color-primary-lighter;
      padding: @size-base;
      display: flex;
      align-items: center;
      .address-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: @size-extra-medium;
        width: @size-extra-medium;
        background: @color-primary-aide;
        color: @color-white;
        border-radius: @border-radius-round;
        font-size: @font-size-small;
        margin-right: 16px;
      }
      .address-text {
        color: @color-text-light;
        font-size: @font-size-base;
        font-weight: @font-weight-strong;
      }
    }
    &-express-result {
      position: relative;
      box-sizing: border-box;
      padding: @size-medium @size-base 0 36px;
      &:before {
        position: absolute;
        top: 40px;
        left: 54px;
        width: 1px;
        height: calc(100% - 40px);
        content: '';
        border-left: 1px dotted @color-gray-light;
        z-index: 1;
      }
      &-block {
        margin-bottom: 64px;
        &:last-child {
          .block-list {
            position: relative;
            &:before {
              position: absolute;
              left: 16px;
              top: -16px;
              z-index: 2;
              width: 6px;
              height: calc(100% + 16px);
              content: '';
              background: @color-white;
            }
          }
        }
      }
      &-block-header {
        box-sizing: border-box;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        color: @color-text-lighter;
        font-size: @font-size-medium;
        font-weight: @font-weight-strong;
        line-height: 1;
        .icon-container {
          position: relative;
          z-index: 3;
          flex-shrink: 0;
          width: @size-medium;
          height: @size-medium;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: @size-small;
          background: @color-gray-lighter;
          border-radius: 50%;
        }
        .icon {
          font-size: @font-size-small;
        }
        &.high-light {
          color: @color-primary-aide;
          .icon-container {
            box-sizing: border-box;
            background: #e9f7f7;
            border: 1px solid @color-primary-aide;
          }
        }
      }
      &-block-list {
        box-sizing: border-box;
        padding-left: @size-large;
      }
      &-block-list-item {
        margin-bottom: @size-medium;
        color: @color-text-lighter;
        font-size: @font-size-base;
        font-weight: @font-weight-strong;
        line-height: 1.4;
        &:not(:first-child) {
          position: relative;
          &:before {
            position: absolute;
            z-index: 2;
            top: 14px;
            left: -46px;
            width: 10px;
            height: 10px;
            content: '';
            background: @color-gray-light;
            border-radius: 50%;
          }
        }
        &-time {
          margin-top: @size-extra-small;
          font-size: @font-size-small;
          font-weight: @font-weight-primary;
          line-height: 1;
        }
        .primary-link {
          color: @color-link;
        }
      }
    }
  }

</style>
